import React, { useEffect, useState, useRef } from 'react';
import { useTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { getFriendlyGameDate } from '../../utils/timeFormat'
import { getTeamEventUrl, SportsBookLinks, getLineHistoryUrl, MarketName, } from '../../utils/gameUtils'
import { TeamMatchup } from './TeamMatchup';
import { OddsValuePair } from './OddsValue';
import { SportsBook } from '../odds/SportsBook';
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync';
import AllButton from './images/All.png'
import ChevronRight from './images/chevron_right.png'
import ChevronLeft from './images/chevron_left.png'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MarketTypeFilter from './MarketTypeFilter';
import { OddsOpenerValue } from './OddsOpenerValue';
import { CircularProgress } from '@material-ui/core';
// import OddsListSeo from './OddsListSeo';
import FullGameImage from './images/FullGame.png'

import {
    Link,
    useParams,
    useLocation,
} from "react-router-dom";
import Overflow from 'react-overflow-indicator';
import { styles } from './OddsListStyles';
import { useGamesListQuery } from '../../hooks/useGamesListQuery';
import RouteUtils from '../../utils/routeUtils'
import { useMatchupsQuery } from '../../hooks/useMatchupsQuery';
import { useConfigQuery } from '../../hooks/useConfigQuery';
import { PageTitle } from '../PageTitle';

export default function OddsList() {
    const classes = styles();
    const location = useLocation();
    const scrollPane = useRef();
    const leftHeading = useRef();
    const [isMarketNotEmpty, setMarketNotEmpty] = useState(true);
    const [isLoaded, setIsLoaded] = useState(false);
    const { league, market, gameTime, season } = useParams();

    const [marketFilter, setMarketFilter] = useState();

    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const { isLoading: configLoading, availableSportsBooks } = useConfigQuery();
    const { isLoading: matchupsLoading, matchups } = useMatchupsQuery(league);
    const { isLoading, games } = useGamesListQuery(league, season, gameTime);
    const [newSportsBooks, setNewSportsBooks] = useState(availableSportsBooks);
    const [showShadow, setShowShadow] = useState(false);

    useEffect(() => {
        if (window.innerWidth < 600) {
            window.addEventListener('scroll', (event) => {
                if (event.target.scrollingElement.scrollTop > 129) {
                    setShowShadow(true);
                } else {
                    setShowShadow(false);
                }
            });
            return () => {
                window.removeEventListener('scroll', () => {})
            }
        }
    }, []);

    useEffect(() => {
        let foundMatch = false;

        for (let game of games) {
            if (game.markets.total) {
                foundMatch = true;
            }
        }
        if (!isLoading) {
            setMarketNotEmpty(foundMatch)
        }
        setTimeout(() => {
            if (scrollPane && scrollPane.current && !isLoaded && games.length > 0 && window.innerWidth < 600) {
                scrollPane.current.node.scrollLeft = 90;
                setIsLoaded(true);
            }
        });
    }, [games]);

    useEffect(() => {
        let tempSportsBooks = [];
        let emptySportsBooks = [];
        availableSportsBooks.forEach(book => {
            let isExist = false;
            let newBook = book === 'BetRivers' ? 'SugarHouseNJ' : book;
            games.forEach(game => {
                if (game.markets[marketFilter] && game.markets[marketFilter][newBook]?.length > 0) {
                    isExist = true;
                }
            });
            if (isExist) {
                tempSportsBooks.push(book);
            } else {
                emptySportsBooks.push(book);
            }
        });
        setNewSportsBooks(tempSportsBooks.concat(emptySportsBooks));
    }, [availableSportsBooks, games]);

    const onFilterChanged = (filter) => {
        localStorage.setItem('marketFilter', filter);
        setMarketFilter(filter);
    }

    useEffect(() => {
        // Convert route url params
        setMarketFilter(RouteUtils.getMarketFilter(league, market));
        localStorage.setItem('marketFilter', RouteUtils.getMarketFilter(league, market));
        setTimeout(() => {
            if (scrollPane && scrollPane.current && games.length > 0 && window.innerWidth < 600) {
                scrollPane.current.node.scrollLeft = 90;
            }
        });
    }, [location]);

    const getFirstGameDay = () => {
        return games.length === 0 ? "" : getFriendlyGameDate(games[0].scheduled_datetime);
    }

    const rows = () => {
        let lastGame = null;
        return matchups.map((matchup, index) => {
            const scheduledTime = new Date(matchup.scheduled_datetime);
            var insertDateRow = lastGame && lastGame.getDate() !== scheduledTime.getDate();
            lastGame = scheduledTime;

            return (
                <>
                    <div className={classes.rowContainer} key={matchup.id || index}>
                        {insertDateRow && <OddsDateRow game={matchup} availableSportsBooks={newSportsBooks} />}
                        <div className={`${classes.row} ${classes.oddsRow}`}>
                            <div className={`${classes.teamMatchup}`}>
                                <TeamMatchup game={matchup} league={league} />
                            </div>
                            <div className={`${classes.col}`}>
                                {
                                    games && games[index] &&
                                    <OddsOpenerValue game={games[index]} marketFilter={marketFilter} />
                                }
                            </div>
                            {
                                !isLargeScreen &&
                                <div className={classes.allButton}>
                                    <div className={classes.stickyButton}>
                                        <Link to={getLineHistoryUrl(league, matchup)} >
                                            <img alt="line history button" src={FullGameImage} style={{ marginTop: 4, height: 24 }} />
                                        </Link>
                                        <GetGameURL game={matchup} league={league} />
                                    </div>
                                </div>
                            }
                            {
                                newSportsBooks.map((book, id) => {
                                    return (
                                        <div className={`${classes.col} `} key={`${book}_${id}`}>
                                            {
                                                games && games[index] &&
                                                <OddsValuePair game={games[index]} marketFilter={marketFilter} sportsBook={book} />
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    <div className={classes.divider} />
                </>
            );
        });
    };

    const handleScroll = (direction) => {
        const rhsWidth = scrollPane.current.node.clientWidth - leftHeading.current.clientWidth;
        if (direction === 'right') {
            scrollPane.current.node.scrollLeft += rhsWidth;
        } else {
            scrollPane.current.node.scrollLeft -= rhsWidth;
        }
    };

    return (
        <>
            {/*<OddsListSeo />*/}
            <Container className={classes.contentContainer}>
                <PageTitle title={`${league.replace('-', ' ')} ${MarketName[marketFilter]}`} />
                <MarketTypeFilter marketFilter={marketFilter} onFilterChanged={onFilterChanged} league={league} gameTime={gameTime} />
                {
                    (matchupsLoading || configLoading) && 
                    <div className={classes.loadingDiv}>
                        <div className={classes.progressCircle}>
                            <CircularProgress />
                        </div>
                    </div>
                }
                {
                    !matchupsLoading && !configLoading &&
                    <Overflow>
                        {
                            availableSportsBooks.length ?
                            <div className={classes.stickyDiv}>
                                <div className={classes.chevronDiv}>
                                    <Overflow.Indicator direction="left">
                                        <img alt="overflow left indicator" className={classes.chevronLeft} src={ChevronLeft} onClick={() => handleScroll('left')} />
                                    </Overflow.Indicator>
                                    <Overflow.Indicator direction="right">
                                        <img alt="overflow right indicator" className={classes.chevronRight} src={ChevronRight} onClick={() => handleScroll('right')} />
                                    </Overflow.Indicator>
                                </div>
                            </div> : null
                        }
                        <div className={classes.stickyGameDateDiv}>
                            <div className={classes.gameDateAbsoluteDiv}>
                                {
                                    availableSportsBooks.length ?
                                    <div className={`${classes.heading} ${classes.gameDateHeader} ${classes.shadowHeader}`} ref={leftHeading}>
                                        <div className={`${classes.alignHeader}`}>{getFirstGameDay()}</div>
                                    </div> : null
                                }
                            </div>
                        </div>
                        <ScrollSync>
                            <div className={classes.table}>
                                <div className={`${classes.header} ${showShadow ? classes.shadow : ''}`}>
                                    <ScrollSyncPane ref={scrollPane}>
                                        <Overflow.Content>
                                            <div className={`${classes.row} ${classes.headerRow}`} name="odds">
                                                {
                                                    availableSportsBooks.length ?
                                                    <>
                                                        <div className={`${classes.leftCol}`}></div>
                                                        <div>
                                                            <div className={`${classes.heading}`}>
                                                                <div className={`${classes.alignHeader}`}>Opener</div>
                                                            </div>
                                                        </div>
                                                    </> : null
                                                }
                                                {
                                                    newSportsBooks.map((name) => (
                                                        <div key={name}>
                                                            <div className={classes.heading}>
                                                                <a href={SportsBookLinks[name]} target="_blank" rel="noreferrer">
                                                                    <SportsBook name={name} />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </Overflow.Content>
                                    </ScrollSyncPane>
                                </div>

                                <ScrollSyncPane>
                                    <div className={classes.items}>
                                        {
                                            !isMarketNotEmpty && !matchups.length ? 
                                            <div className={classes.relativeDiv}>
                                                <div className={classes.marketEmptyDiv}>
                                                    <h6 style={{fontSize: 20}}>NO MARKET DATA AVAILABLE</h6>
                                                </div>
                                            </div> : null
                                        }
                                        {rows()}
                                    </div>
                                </ScrollSyncPane>
                            </div>
                        </ScrollSync>
                    </Overflow>
                }
            </Container>
        </>
    );
};

const GetGameURL = ({ game, league }) => {
    let url = getTeamEventUrl(league, game);

    return (
        <Link to={url}>
            <img alt="all button" src={AllButton} />
        </Link>
    )
}

export const OddsDateRow = ({ game, availableSportsBooks }) => {
    const dateTime = new Date(game.scheduled_datetime);
    const classes = styles();

    return (
        <div className={`${classes.row} ${classes.dateRow}`}>
            <div className={`${classes.col} ${classes.dateRowCol}`}>
                <p>{getFriendlyGameDate(dateTime)}</p>
            </div>
            {availableSportsBooks.map((book) => {
                return (
                    <div className={`${classes.col}`} key={book}>
                    </div>
                );
            })}
        </div>
    );
}